// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fff3e8d0","769":"b6768a29"}[chunkId] + ".chunk.css";
};